import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/logo.png';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://auditoria.tramites.notaria4otavalo.com.ec/api/users/auth/login/', {
        username,
        password,
      });
      const token = response.data.access;
      await login(token); // Usamos la función login del AuthContext
      toast.success('Inicio de sesión exitoso', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      const { is_notario, is_contador } = response.data.user;
      if (is_notario) {
        navigate('/dashboard/notario');
      } else if (is_contador) {
        navigate('/dashboard/contador');
      } else {
        toast.error('Rol no identificado', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      toast.error('Error al iniciar sesión. Verifica tus credenciales.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="min-h-screen flex flex-col items-center justify-center text-white px-6 py-10"
    >
      <header className="flex flex-col items-center mb-10">
        <motion.img
          src={logo}
          alt="Logo Notaría 4 Cantón Otavalo"
          className="w-40 h-auto mb-6"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <motion.h1
          className="text-5xl font-extrabold tracking-tight"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Iniciar Sesión
        </motion.h1>
      </header>
      <main className="max-w-md w-full bg-notaria-blue-1 bg-opacity-80 p-8 rounded-xl shadow-2xl">
        <motion.form
          onSubmit={handleSubmit}
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="mb-6">
            <label htmlFor="username" className="block text-lg font-semibold mb-2">Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-3 rounded-lg bg-notaria-blue-2 text-white focus:outline-none focus:ring-2 focus:ring-notaria-yellow"
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-lg font-semibold mb-2">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 rounded-lg bg-notaria-blue-2 text-white focus:outline-none focus:ring-2 focus:ring-notaria-yellow"
              required
            />
          </div>
          <motion.button
            type="submit"
            className="w-full bg-notaria-yellow text-notaria-blue-1 font-bold py-3 rounded-full shadow-lg hover:bg-notaria-red hover:text-white transition-all duration-300 transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Iniciar Sesión
          </motion.button>
        </motion.form>
        <motion.div
          className="mt-6 text-center"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <Link to="/" className="text-notaria-yellow hover:underline">Volver al Inicio</Link>
        </motion.div>
      </main>
      <ToastContainer />
    </motion.div>
  );
};

export default Login;